module.exports = __webpack_public_path__ + "static/media/eth-icon.7ac4d18b.svg";